import React from 'react';
import BridgeChat from './BridgeChat';

// Private line to the external OpenClaw Chief of Staff — a BridgeChat over /cos.
export default function ChiefOfStaff({ onBack = null }) {
  return (
    <BridgeChat
      suggestReplies
      base="/cos"
      onBack={onBack}
      title="Chief of Staff"
      subtitle="Your private line · full company visibility"
      placeholder="Message the Chief of Staff…"
      agentLabel="♟ Chief of Staff"
      emptyTitle="This is your direct line to the Chief of Staff."
      emptyBody="It can see across everything — jobs, schedule, POs, the whole operation. Ask it anything."
      accent="#4f46e5"
      icon="♟"
      waitingText="Chief of Staff is on it…"
      pill={{ text: 'Private', bg: '#eef2ff', color: '#3730a3', dot: '#4f46e5' }}
    />
  );
}
